import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import {
  APP_FILE_IMPORTS_ROUTE,
  APP_EXTRACT_PRODUCST_WITH_API,
  APP_FILE_AGENCY_BILL_ROUTE,
  APP_FILE_MANUAL_BANK_RECONCILIATION_ROUTE,
} from "./ImportLineSheet.constants";
import { MODULE_IDS } from "../../constants/enums";

const ImportLineSheetPage = Loadable(
  lazy(() =>
    import("./ImportLineSheetPage").then(({ ImportLineSheetPage }) => ({
      default: ImportLineSheetPage,
    }))
  )
);

const ReconcilliationDetailsList = Loadable(
  lazy(() =>
    import("./ReconcilliationDetailsList").then(
      ({ ReconcilliationDetailsList }) => ({
        default: ReconcilliationDetailsList,
      })
    )
  )
);

export const ReconciliationDetails = Loadable(
  lazy(() =>
    import("./ReconciliationDetails").then(({ ReconciliationDetails }) => ({
      default: ReconciliationDetails,
    }))
  )
);

const ExtractDataFromPdf = Loadable(
  lazy(() =>
    import("./ExtractDataFromPdf").then(({ ExtractDataFromPdf }) => ({
      default: ExtractDataFromPdf,
    }))
  )
);
const AgencyBillReconciliation = Loadable(
  lazy(() =>
    import("./AgencyBillReconciliaton").then(
      ({ AgencyBillReconciliation }) => ({
        default: AgencyBillReconciliation,
      })
    )
  )
);

const DuplicateTransactionItems = Loadable(
  lazy(() =>
    import("./DuplicateTransactionItems").then(
      ({ DuplicateTransactionItems }) => ({
        default: DuplicateTransactionItems,
      })
    )
  )
);

const ManageBankReconciliationTabs = Loadable(
  lazy(() =>
    import("../Reconciliation/ManualBankReconciliationTabs").then(
      ({ ManageBankReconciliationTabs }) => ({
        default: ManageBankReconciliationTabs,
      })
    )
  )
);

const ReconciliationTabs = Loadable(
  lazy(() =>
    import("../Reconciliation/ReconciliationTabs").then(
      ({ ReconciliationTabs }) => ({
        default: ReconciliationTabs,
      })
    )
  )
);
export const fileUploadWithAIRouter = [
  {
    path: `${APP_FILE_IMPORTS_ROUTE}/reconciliation`,
    exact: true,
    element: (
      <AuthorizedRoute
        moduleKeys={[
          MODULE_IDS.RECONCILIATION_LIST,
          MODULE_IDS.RECONCILIATION_MANUAL_RECONCILIATION,
          MODULE_IDS.RECONCILIATION_MANUAL_BANK_RECONCILIATION,
          MODULE_IDS.RECONCILIATION_DUPLICATE_TRANSACTION_ITEMS,
        ]}
      >
        <ReconciliationTabs />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_IMPORTS_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ImportLineSheetPage />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_IMPORTS_ROUTE}/get-reconcilliation-details/template/:templateCode/document/:documentCode`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ReconciliationDetails />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_IMPORTS_ROUTE}/list`,
    exact: true,
    element: (
      <AuthorizedRoute  moduleKeys={[MODULE_IDS.RECONCILIATION_LIST]}>
        <ReconcilliationDetailsList />
      </AuthorizedRoute>
    ),
  },
  // {
  // 	path: `${APP_EXCEL_FILE_IMPORTS_ROUTE}`,
  // 	exact: true,
  // 	element: (
  // 		<AuthorizedRoute
  // 			allowFullAccess
  // 			moduleKeys={[]}
  // 		>
  // 			<ImportExcelLineSheet />
  // 		</AuthorizedRoute>
  // 	),
  // },
  // {
  // 	path: `${APP_PDF_FILE_IMPORTS_ROUTE}`,
  // 	exact: true,
  // 	element: (
  // 		<AuthorizedRoute
  // 			allowFullAccess
  // 			moduleKeys={[]}
  // 		>
  // 			<ManageSingleFileUploadWithAI />
  // 		</AuthorizedRoute>
  // 	),
  // },
  {
    path: `${APP_EXTRACT_PRODUCST_WITH_API}/document/:documentCode/proccess/:proccessCode`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ExtractDataFromPdf />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_AGENCY_BILL_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute  moduleKeys={[MODULE_IDS.RECONCILIATION_MANUAL_RECONCILIATION]}>
        <AgencyBillReconciliation />
      </AuthorizedRoute>
    ),
  },
    {
    path: `/duplicate-tarnsaction-items`,
    exact: true,
    element: (
      <AuthorizedRoute  moduleKeys={[MODULE_IDS.RECONCILIATION_DUPLICATE_TRANSACTION_ITEMS]}>
        <DuplicateTransactionItems />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_MANUAL_BANK_RECONCILIATION_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.RECONCILIATION_MANUAL_BANK_RECONCILIATION]}>
        <ManageBankReconciliationTabs />
      </AuthorizedRoute>
    ),
  },
];
